/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconReservedLine = createReactComponent("outline", "reserved-line", "IconReservedLine", [["path", { "d": "M9 20h6", "key": "svg-0" }], ["path", { "d": "M12 14v6", "key": "svg-1" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M9 9h6", "key": "svg-3" }]]);

export { IconReservedLine as default };
//# sourceMappingURL=IconReservedLine.mjs.map
